
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {StaffScheduleUpdateRequestType} from "@/form/staff/schedule/update.types";

@Component
export default class StaffScheduleUpdateForm extends Form{
    @Validate(required, i18nText("Не выбрана запись"))
    id: number = 0;

    month: number | null | undefined;
    year: number | null | undefined;
    day: number | null | undefined;

    working_day: boolean | null | undefined;

    work_start: string | null | undefined;
    work_finish: string | null | undefined;

    break_start: string | null | undefined;
    break_finish: string | null | undefined;

    getFormData(): StaffScheduleUpdateRequestType {
        return {
            id: this.id,
            month: this.month,
            year: this.year,
            day: this.day,
            working_day: this.working_day,
            work_start: this.work_start,
            work_finish: this.work_finish,
            break_start: this.break_start,
            break_finish: this.break_finish
        }
    }
    setFormData(data: StaffScheduleUpdateRequestType): void {
        this.id = data.id;
        this.month = data.month;
        this.year = data.year;
        this.day = data.day;
        this.working_day = data.working_day;
        this.work_start = data.work_start;
        this.work_finish = data.work_finish;
        this.break_start = data.break_start;
        this.break_finish = data.break_finish;
    }
}
